module.exports = __webpack_public_path__ + "img/powered_by_allsan2.6fa67c5d.png";